import React from "react";
import {withRouter} from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarListRevamp from "./component";
import {fetchCarListV2, fetchSimilarCarListV2, updateSSRStatus, reloadCarList, resetCarList} from "../car-listing/actions";
import { fetchWishlistedCarsList } from "../my-wishlist/actions";
import { clearAllFilters, setMarketingCategory, updateSelectedOnScreenFilter, updateAllFiltersVisibility, updateSortModalVisibility} from "../filters/actions";
import { getInhouseEligibility, getDrivaPreApprovalLoanDetails, getPreApprovalLoanDetails } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { closeClpNudgeHandler } from "../../au.configuration/actions";

const mapStateToProps = ({
    carListing: {
        content,
        totalCars,
        page,
        isLoading,
        config,
        isSSR,
        shouldReloadList,
        personalised,
        ipDetectedState,
        metaContent,
        similarCarsContent,
        totalSimilarCars,
        isSimilarCarLoading,
        totalSimilarPages,
        similarCarPage,
        buyWithConfidence
    },
    filters: {
        allFilters,
        urlOptions,
        selectedFilters,
        appliedFilters,
        appliedSuggestions,
        marketCategoryEvent,
        selectedOnScreenFilter,
        fbEventType,
        isSortModalOpen,
        selectedSort
    },
    preApprovalLoan: {
        financeData: {
            loanType
        },
        inHouseFinanceEligibility,
        preApproved,
        quotesAvailable,
        absolutePermissibleLoanAmount,
        maxPermissibleRepaymentPerWeek,
        stEligible
    },
    tradeIn: {
        userTradeInData,
        tradeInToggleSelected
    },
    clpData: {
        inlineFilters
    },
    user: {
        userGeoData
    },
    abExperiment: {
        webPriceDropDesktop,
        galleryOnTheFlyDesktop
    },
    config: {
        testDriveConfig,
        ratingsConfig: {
            ratingAndReviews
        } = {}

    }
}) => ({
    content,
    totalCars,
    page,
    isLoading,
    config,
    allFilters,
    loanType,
    isSSR,
    urlOptions,
    selectedFilters,
    appliedFilters,
    appliedSuggestions,
    shouldReloadList,
    personalised,
    ipDetectedState,
    inHouseFinanceEligibility,
    preApproved,
    userTradeInData,
    tradeInToggleSelected,
    quotesAvailable,
    marketCategoryEvent,
    selectedOnScreenFilter,
    fbEventType,
    metaContent,
    isSortModalOpen,
    selectedSort,
    similarCarsContent,
    totalSimilarCars,
    isSimilarCarLoading,
    totalSimilarPages,
    similarCarPage,
    inlineFilters,
    buyWithConfidence,
    absolutePermissibleLoanAmount,
    maxPermissibleRepaymentPerWeek,
    stEligible,
    userGeoData,
    webPriceDropDesktop,
    galleryOnTheFlyDesktop,
    testDriveConfig,
    ratingAndReviews
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCarListConnect: fetchCarListV2,
    fetchSimilarCarConnect: fetchSimilarCarListV2,
    updateSSRStatusConnect: updateSSRStatus,
    reloadCarListConnect: reloadCarList,
    resetCarListConnect: resetCarList,
    fetchWishlistedCarsListConnect: fetchWishlistedCarsList,
    clearAllFiltersConnect: clearAllFilters,
    getInhouseEligibilityConnect: getInhouseEligibility,
    getDrivaPreApprovalLoanDetailsConnect: getDrivaPreApprovalLoanDetails,
    getPreApprovalLoanDetailsConnect: getPreApprovalLoanDetails,
    setMarketingCategoryConnect: setMarketingCategory,
    updateSelectedOnScreenFilterConnect: updateSelectedOnScreenFilter,
    updateAllFiltersVisibilityConnect: updateAllFiltersVisibility,
    updateSortModalVisibilityConnect: updateSortModalVisibility,
    closeClpNudgeHandlerConnect: closeClpNudgeHandler

}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarListRevamp));
